export default __webpack_public_path__ + "static/media/magnifying-glass.2ab3538b.svg";